import { Component, DestroyRef, OnInit, computed, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DatePipe } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NewCustomerNoteRequest } from '../../../interfaces/new-customer-requests.model';
import { NewCustomerService } from '../../../services/new-customer.service';

// Nota del nuovo cliente, facoltativa: con il titolo diventa una nota del cliente
@Component({
  selector: 'ord-new-customer-note',
  imports: [DatePipe, MatButtonModule, MatFormFieldModule, MatInputModule, MatSlideToggleModule, ReactiveFormsModule],
  templateUrl: './new-customer-note.html',
  styleUrl: './new-customer-note.scss',
})
export class NewCustomerNote implements OnInit {
  readonly flow = inject(NewCustomerService);
  private readonly formBuilder = inject(FormBuilder);
  private readonly destroyRef = inject(DestroyRef);

  readonly today = new Date();
  readonly contrassegno = computed(() => this.flow.payment().condizione?.type === 'CONTATTO');

  readonly form = this.formBuilder.nonNullable.group({
    titolo: ['', Validators.maxLength(100)],
    testo: '',
    addOrdine: true,
  });

  ngOnInit(): void {
    const note = this.flow.note();
    if (note) {
      this.form.setValue({ titolo: note.titolo, testo: note.testo ?? '', addOrdine: note.addOrdine }, { emitEvent: false });
    }

    this.form.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.flow.setNote(this.note));
  }

  get note(): NewCustomerNoteRequest {
    const value = this.form.getRawValue();
    return {
      titolo: value.titolo.trim(),
      testo: value.testo.trim() || null,
      data: this.today.toISOString(),
      addOrdine: value.addOrdine,
    };
  }

  // Il testo senza titolo non basta a creare la nota
  get valid(): boolean {
    const value = this.form.getRawValue();
    return !!value.titolo.trim() || !value.testo.trim();
  }

  continue(): void {
    if (!this.valid) {
      return;
    }

    this.flow.setNote(this.note);
    this.flow.go('gdpr');
  }
}
